import { BackupAction } from './plan-backup-actions-model';

export class BackupActionPost extends BackupAction {
  constructor() {
    super();
  }
  public RunOnBackupFailure: boolean;
}
